import { ChangeDetectionStrategy, Component, ContentChild, ContentChildren, Input, ViewEncapsulation } from '@angular/core';
import { ListItemActionsDirective } from '@portal-core/ui/list/directives/list-item-actions/list-item-actions.directive';
import { ListItemLineDirective } from '@portal-core/ui/list/directives/list-item-line/list-item-line.directive';

@Component({
  selector: 'mc-path-list-item',
  templateUrl: './path-list-item.component.html',
  styleUrls: ['./path-list-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PathListItemComponent {
  @Input() path: string;

  @ContentChild(ListItemActionsDirective) listItemActionsDirective: ListItemActionsDirective;
  @ContentChildren(ListItemLineDirective) listItemLineDirectives: ListItemLineDirective[];
}
